import styled from "styled-components";

export const StyledContainer = styled.div`
  width: 95%;
  max-width: 1000px;
  margin: 0 auto;
`;
